import axiosInstance from "../utils/axiosInstance";

export type GdBrandType = "series_tour" | "cruise";

export interface GdBrand {
  id: string;
  title: string;
  subtitle?: string;
  description?: string;
  redirectionUrl: string;
  brandType: GdBrandType;
  sequence: number;
  tourCount: number;
  logo?: string;
  backgroundImage?: string;
}

interface GdBrandPayload {
  id: string;
  attributes: {
    title: string;
    subtitle?: string;
    description?: string;
    redirection_url: string;
    brand_type: GdBrandType;
    sequence: number;
    tour_count: number;
    logo?: string;
    background_image?: string;
  };
}

class GdBrandsApi {
  getBrands(brandType?: GdBrandType): Promise<GdBrand[]> {
    return axiosInstance.get("/b2c2b/api/v1/gd_brands", {
      params: brandType ? { brand_type: brandType } : undefined,
    }).then(response => (
      response.data.data.map((brand: GdBrandPayload) => ({
        id: brand.id,
        title: brand.attributes.title,
        subtitle: brand.attributes.subtitle,
        description: brand.attributes.description,
        redirectionUrl: brand.attributes.redirection_url,
        brandType: brand.attributes.brand_type,
        sequence: brand.attributes.sequence,
        tourCount: brand.attributes.tour_count,
        logo: brand.attributes.logo,
        backgroundImage: brand.attributes.background_image,
      }))
    ));
  }
}

export default new GdBrandsApi();
